<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let item;
    export let action;
</script>

<td class="action-col">
    <div>
        {#if action == "Add"}
            <img
                id="action-image"
                src="images/iconInfo44@2x.png"
                alt="Add this item"
                on:click={() => dispatch("item-add", { item: item })}
            />
            {:else if action == "Edit"}
            <img
                id="action-image"
                src="images/iconInfo44@2x.png"
                alt="Edit this item"
                on:click={() => dispatch("item-edit", { item: item })}
            />
        {:else if action == "Info"}
            <img
                id="action-image"
                src="images/iconInfo44@2x.png"
                alt="Select this item"
                on:click={() => dispatch("item-select", { item: item })}
            />
        {:else if action == "Map"}
            <img
                id="action-image"
                src="images/iconMap44@2x.png"
                alt="Find this item on the map"
                on:click={() => dispatch("find-on-map", { item: item })}
            />
        {:else if action == "Remove"}
            <img
                id="action-image"
                src="images/iconInfo44@2x.png"
                alt="Remove this item"
                on:click={() => dispatch("item-remove", { item: item })}
            />
        {/if}
    </div>
</td>

<style>
    #action-image {
        width: 32px;
        height: 32px;
    }
</style>
